"use client";

import { Button } from "@mantine/core";
import Link from "next/link";
import { ReactNode } from "react";
import classes from "./primary-cta-button.module.css";

interface PrimaryCtaButtonProps {
  href: string;
  children: ReactNode;
  rightSection?: ReactNode;
  /** Optional: skip the wrapper (no centering / marginTop). */
  noWrap?: boolean;
  variant?: "light" | "dark";
}

export default function PrimaryCtaButton({
  href,
  children,
  rightSection,
  noWrap = false,
  variant = "light",
}: PrimaryCtaButtonProps) {
  const button = (
    <Button
      component={Link}
      href={href}
      size="lg"
      radius="md"
      color="darkblue"
      className={classes.button}
      data-variant={variant}
      rightSection={rightSection}
    >
      {children}
    </Button>
  );
  if (noWrap) return button;
  return <div className={classes.wrap}>{button}</div>;
}
